import { DataTableColumn } from './../../generics/data-table/data-table.component';
import { ServicesSelectorDialogComponent } from './../../../dialogs/services-selector-dialog/services-selector-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { ServiceConfiguration } from '../../../models/service.model';
import { ServicesService } from 'src/app/services/services.service';
import { SelectOptionsService } from './../../../services/select-options.service';
import { Locality, localityRequiredValidator } from './../../../models/locality.model';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { ErrorResponse } from './../../../models/error.model';
import { UtilsService } from './../../../services/utils.service';
import { Office } from './../../../models/office.model';
import { OfficesService } from './../../../services/offices.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatStepper } from '@angular/material/stepper';
import { CSVColumnMap } from '../../generics/bulk-creator/bulk-creator.component';
import { generateAddressFG } from 'src/app/models/address.model';
import { ID } from '../../../models/ID.model';

@Component({
    selector: 'app-edit-office',
    templateUrl: './edit-office.component.html',
    styleUrls: ['./edit-office.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class EditOfficeComponent implements OnInit {

    office: Office;

    generalSectionFG = new UntypedFormGroup({
        nombre: new UntypedFormControl('', [Validators.required]),
        sucursal: new UntypedFormControl('', [Validators.required]),
        telefonoFijo: new UntypedFormControl('', [Validators.required]),
        cuit: new UntypedFormControl('', [Validators.required, Validators.minLength(11), Validators.maxLength(11), this.utilsService.numberFormValidator]),
        idRemax: new UntypedFormControl('', []),
    });

    addressSectionFG = generateAddressFG();

    responsibleSectionFG = new UntypedFormGroup({
        nombreResponsable: new UntypedFormControl('', [Validators.required]),
        apellidoResponsable: new UntypedFormControl('', [Validators.required]),
        celular: new UntypedFormControl('', [Validators.required]),
    });

    credentialsSectionFG = new UntypedFormGroup({
        email: new UntypedFormControl('', [Validators.required, Validators.email])
    });

    servicesOverrides: ServiceConfiguration[] = [];

    @ViewChild('stepper', { static: true })
    stepper: MatStepper;

    @ViewChild('editServiceFieldColumnTemplate', { static: true })
    editServiceFieldColumnTemplate: TemplateRef<any>;

    bulkCreatorColumnMaps: CSVColumnMap[] = [
        { key: 'nombre', description: 'Nombre' },
        { key: 'sucursal', description: 'Sucursal' },
        { key: 'telefonoFijo', description: 'Teléfono' },
        { key: 'cuit', description: 'CUIT' },
        { key: 'calle', description: 'Calle' },
        { key: 'numero', description: 'Número' },
        { key: 'piso', description: 'Piso' },
        { key: 'departamento', description: 'Departamento' },
        { key: 'codigoPostal', description: 'Código postal' },
        { key: 'provincia', description: 'Provincia' },
        { key: 'municipio', description: 'Municipio' },
        { key: 'localidad', description: 'Localidad' },
        { key: 'nombreResponsable', description: 'Nombre reponsable' },
        { key: 'apellidoResponsable', description: 'Apellido responsable' },
        { key: 'celular', description: 'Teléfono responsable' },
        { key: 'email', description: 'Email' },
        { key: 'idRemax', description: 'Oficina remax ID' }
    ];

    validatorFormGroup = new UntypedFormGroup({
        nombre: new UntypedFormControl('', [Validators.required]),
        sucursal: new UntypedFormControl('', [Validators.required]),
        telefonoFijo: new UntypedFormControl('', [Validators.required]),
        cuit: new UntypedFormControl('', [Validators.required, Validators.minLength(11), Validators.maxLength(11), this.utilsService.numberFormValidator]),
        // TODO Falta el tipo de calle
        calle: new UntypedFormControl('', [Validators.required]),
        numero: new UntypedFormControl('', [Validators.required]),
        piso: new UntypedFormControl('', []),
        departamento: new UntypedFormControl('', []),
        codigoPostal: new UntypedFormControl('', [Validators.required]),
        provincia: new UntypedFormControl('', []),
        municipio: new UntypedFormControl('', []),
        localidad: new UntypedFormControl('', []),
        nombreResponsable: new UntypedFormControl('', [Validators.required]),
        apellidoResponsable: new UntypedFormControl('', [Validators.required]),
        celular: new UntypedFormControl('', [Validators.required]),
        email: new UntypedFormControl('', [Validators.required, Validators.email]),
    });

    availableServices: ServiceConfiguration[] = [];

    constructor(
        private route: ActivatedRoute,
        private officesService: OfficesService,
        public utilsService: UtilsService,
        private router: Router,
        private selectOptionsService: SelectOptionsService,
        private dialog: MatDialog,
        private servicesService: ServicesService
    ) { }

    ngOnInit(): void {
        this.route.params.subscribe(params => {
            if (params?.id) {
                this.getOffice(params.id);
            }
        });
        this.getServices();
        this.generalSectionFG.controls.sucursal.valueChanges.subscribe(newValue => {
            this.checkSucursalAvailability(newValue);
        });
    }

    getOffice(id: ID) {
        this.officesService.getOfficeById(id).subscribe(office => {
            this.office = office;
            this.fillFormsWithOfficeData();
        }, (error: ErrorResponse) => this.utilsService.alert('Error al obtener datos de la oficina', error.error?.descripcion));
    }

    getServices() {
        this.servicesService.getServices(0, 50, [], {}).subscribe(services => {
            this.availableServices = [];
            services.body.forEach(service => {
                this.availableServices.push({ servicio: service, tipoCotizacion: 'VIVIENDA' });
                this.availableServices.push({ servicio: service, tipoCotizacion: 'COMERCIAL' });
            });
        }, (error: ErrorResponse) => this.utilsService.alert('Error al obtener servicios disponibles', error.error?.descripcion));
    }

    checkSucursalAvailability(sucursal: string) {
        if (sucursal !== this.office?.sucursal) {
            this.officesService.isAvailable('sucursal', sucursal).subscribe(response => {
                let errors: any;
                if (!response.disponible)
                    errors = { notAvailable: true };
                this.generalSectionFG.controls.sucursal.setErrors(errors);
            }, () => {}); // Ignoramos el error
        }
    }

    fillFormsWithOfficeData() {
        this.generalSectionFG.setValue({
            nombre: this.office.nombre,
            sucursal: this.office.sucursal,
            telefonoFijo: this.office.telefonoFijo,
            cuit: this.office.cuit,
            idRemax: this.office.idRemax,
        });
        this.addressSectionFG.setValue({
            tipoCalle: this.office.direccion.tipoCalle,
            calle: this.office.direccion.calle,
            numero: this.office.direccion.numero,
            piso: this.office.direccion.piso,
            departamento: this.office.direccion.departamento,
            codigoPostal: this.office.direccion.codigoPostal,
            localidad: this.office.direccion.localidad
        });
        this.responsibleSectionFG.setValue({
            nombreResponsable: this.office.nombreResponsable,
            apellidoResponsable: this.office.apellidoResponsable,
            celular: this.office.celular
        });
        this.credentialsSectionFG.setValue({
            email: this.office.email
        });
        this.credentialsSectionFG.controls.email.disable();
        if (this.office.servicios) {
            this.updateServices(this.office.servicios);
        }
    }

    getResultingOffice() {
        return {
            id: this.office?.id,
            nombre: this.generalSectionFG.value.nombre,
            sucursal: this.generalSectionFG.value.sucursal,
            telefonoFijo: this.generalSectionFG.value.telefonoFijo,
            cuit: this.generalSectionFG.value.cuit,
            idRemax: this.generalSectionFG.value.idRemax,
            direccion: {
                tipoCalle: this.addressSectionFG.value.tipoCalle,
                calle: this.addressSectionFG.value.calle,
                numero: this.addressSectionFG.value.numero,
                piso: this.addressSectionFG.value.piso,
                departamento: this.addressSectionFG.value.departamento,
                codigoPostal: this.addressSectionFG.value.codigoPostal,
                localidad: this.addressSectionFG.value.localidad
            },
            nombreResponsable: this.responsibleSectionFG.value.nombreResponsable,
            apellidoResponsable: this.responsibleSectionFG.value.apellidoResponsable,
            celular: this.responsibleSectionFG.value.celular,
            email: this.credentialsSectionFG.value.email,
            servicios: this.servicesOverrides
        } as Office;
    }

    createOffice() {
        if (!this.generalSectionFG.valid) {
            this.stepper.selectedIndex = 0;
            return;
        } else if (!this.addressSectionFG.valid) {
            this.stepper.selectedIndex = 1;
            return;
        } else if (!this.responsibleSectionFG.valid) {
            this.stepper.selectedIndex = 2;
            return;
        } else if (!this.office && !this.credentialsSectionFG.valid) {
            this.stepper.selectedIndex = 4;
            return;
        }
        const office: Office = this.getResultingOffice();
        if (this.office) {
            this.officesService.editOffice(office).subscribe(_ => {
                this.router.navigate(['oficinas']);
            }, (error: ErrorResponse) => this.utilsService.alert('Error al modificar oficina', error.error?.descripcion));
        } else {
            this.officesService.createOffice(office).subscribe(_ => {
                this.router.navigate(['oficinas']);
            }, (error: ErrorResponse) => this.utilsService.alert('Error al crear oficina', error.error?.descripcion));
        }
    }

    getBulkCreatorErrors = (row: any) => {
        const errors = [];
        if (row) {
            this.validatorFormGroup.setValue(row);
            Object.keys(this.validatorFormGroup.controls).map(controlName => {
                const control = this.validatorFormGroup.controls[controlName];
                if (!control.valid) {
                    Object.keys(control.errors).forEach(error => {
                        errors.push(`Campo: ${controlName}, error: ${error}.`);
                    });
                }
            });
        }
        return errors;
    }

    async getLocality(provinceName: string, municipalityName: string, localityName: string, index: number): Promise<Locality> {
        const provinces = await this.selectOptionsService.getProvinces().toPromise();
        const province = provinces.find(p => p.descripcion === provinceName || p.codigo === provinceName);
        if (province) {
            const municipalities = await this.selectOptionsService.getMunicipalities(province.codigo).toPromise();
            const municipality = municipalities.find(m => m.descripcion === municipalityName || m.codigo === municipalityName);
            if (municipality) {
                const localities = await this.selectOptionsService.getLocalities(province.codigo, municipality.codigo).toPromise();
                const locality = localities.find(l => l.descripcion === localityName || l.codigo === localityName);
                if (locality) {
                    return locality;
                } else {
                    throw new Error('Localidad no encontrada en nuestra base de datos, fila: ' + index + 1);
                }
            } else {
                throw new Error('Municipalidad no encontrada en nuestra base de datos, fila: ' + index + 1);
            }
        } else {
            throw new Error('Provincia no encontrada en nuestra base de datos, fila: ' + index + 1);
        }
    }

    parsePhone(phoneString: string, index: number) {
        try {
            return this.utilsService.parsePhone(phoneString);
        } catch {
            throw new Error(`Error al parsear teléfono en la linea ${index + 1}, un ejemplo de teléfono correcto es: +54-911-22323223.`);
        }
    }

    bulkCreatorSubmit = async (values: any[]) => {
        const offices = await Promise.all(values.map(async (row, index) => ({
            nombre: row.nombre,
            sucursal: row.sucursal,
            telefonoFijo: this.parsePhone(row.telefonoFijo, index),
            cuit: row.cuit,
            idRemax: row.idRemax,
            nombreResponsable: row.nombreResponsable,
            apellidoResponsable: row.apellidoResponsable,
            celular: this.parsePhone(row.celular, index),
            email: row.email,
            direccion: {
                calle: row.calle,
                numero: row.numero,
                piso: row.piso,
                departamento: row.departamento,
                codigoPostal: row.codigoPostal,
                localidad: await this.getLocality(row.provincia, row.municipio, row.localidad, index)
            }
        } as Office)));
        return await this.officesService.bulkLoad(offices).toPromise();
    }

    updateServices(services?: ServiceConfiguration[]) {
        this.servicesOverrides = services?.map(service => ({
            id: service.id,
            porcentaje: service.porcentaje,
            pricing: service.pricing,
            topeMinimo: service.topeMinimo,
            topeMaximo: service.topeMaximo,
            descuentoContado: service.descuentoContado,
            descuentoFinanciado: service.descuentoFinanciado,
            tipoCotizacion: service.tipoCotizacion,
            servicio: service.servicio
        })) ?? [];
    }

    openServicesSelectorModal() {
        const available = this.availableServices.map(service => {
            const override = this.servicesOverrides.find(serviceOverride => serviceOverride.servicio.id === service.servicio.id && serviceOverride.tipoCotizacion === service.tipoCotizacion);
            return override ?? service;
        });
        this.dialog.open(ServicesSelectorDialogComponent, { data: {
            available,
            selected: this.servicesOverrides
        }}).afterClosed().subscribe((response?: ServiceConfiguration[] | false) => {
            if (response !== false && response !== undefined) {
                this.updateServices(response);
            }
        });
    }

    getServicesTableColumns() {
        return [
            { name: 'Nombre', prop: 'servicio.nombre' },
            { name: 'Producto', prop: 'servicio.tipoProducto', type: 'text' },
            { name: 'Tipo de cotización', prop: 'tipoCotizacion' },
            { name: 'Porcentaje', template: this.editServiceFieldColumnTemplate, parseValue: (row, column, index) => ({ key: 'porcentaje', default: this.utilsService.beautifyNumber(row.servicio?.porcentajeDefault, 2) + '%' }) },
            { name: 'Pricing', template: this.editServiceFieldColumnTemplate, parseValue: (row, column, index) => ({ key: 'pricing', default: this.utilsService.beautifyNumber(row.servicio?.pricingDefault, 4) }) },
            { name: 'Tope máximo', template: this.editServiceFieldColumnTemplate, parseValue: (row, column, index) => ({ key: 'topeMaximo', default: '$' + this.utilsService.beautifyNumber(row.servicio?.topeMaximoDefault, 2) }) },
            { name: 'Tope mínimo', template: this.editServiceFieldColumnTemplate, parseValue: (row, column, index) => ({ key: 'topeMinimo', default: '$' + this.utilsService.beautifyNumber(row.servicio?.topeMinimoDefault, 2) }) },
            { name: 'Descuento contado', template: this.editServiceFieldColumnTemplate, parseValue: (row, column, index) => ({ key: 'descuentoContado', default: this.utilsService.beautifyNumber(row.servicio?.descuentoContadoDefault, 2) + '%' }) },
            { name: 'Descuento financiado', template: this.editServiceFieldColumnTemplate, parseValue: (row, column, index) => ({ key: 'descuentoFinanciado', default: this.utilsService.beautifyNumber(row.servicio?.descuentoFinanciadoDefault, 2) + '%' }) },
        ] as DataTableColumn[];
    }
}
